import PropTypes from 'prop-types';
import React from 'react';
import Button from '@99designs/react-components/components/Button';
import { PopoverCard } from '@99designs/react-components/components/PopoverCard';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import onboardingPrompt from 'contest/components/onboarding-prompts/onboardingPrompt';
import contestStageSelector from 'contest/components/onboarding-prompts/contestStageSelector';

const FinalistDrawerOnboardingPromptComponent = ({ dismiss, children }) => {
    return (
        <PopoverCard
            layerSelector="#drawer-overlay-layer"
            variations={['onboarding-prompt']}
            placement="top"
            card={
                <div>
                    <h5 className="heading heading--h5 heading--pacific">
                        <FormattedMessage id="contest_finalist_drawer_onboarding_title" />
                    </h5>
                    <p>
                        <FormattedHTMLMessage id="contest_finalist_drawer_onboarding_message_html" />
                    </p>
                    <Button variations={['info', 'small']} onClick={dismiss}>
                        <FormattedMessage id="contest_finalist_drawer_onboarding_button" />
                    </Button>
                </div>
            }
        >
            <span onClick={dismiss}>{children}</span>
        </PopoverCard>
    );
};

FinalistDrawerOnboardingPromptComponent.propTypes = {
    dismiss: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default contestStageSelector(
    ['open'],
    onboardingPrompt('finalist-drawer', 300, FinalistDrawerOnboardingPromptComponent)
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/FinalistDrawerPrompt.js